import {View} from 'react-native';
import React from 'react';
const RNFS = props => {
   return <View>{props.chidren}</View>;
};

export default RNFS;
